import * as Yup from "yup";

export default Yup.object().shape({
    height: Yup.number("Please enter height")
    .nullable().required("Please enter height"),
    width: Yup.number("Please enter width")
        .nullable().required("Please enter width"),
});